<template>
  <div class="pusher">
    <!-- Page Contents -->
    <div class="ui inverted vertical center aligned segment">

      <div class="ui container">
        <div class="ui large secondary inverted pointing menu">
          <a class="toc item">
            <i class="sidebar icon"></i>
          </a>

          <router-link :to="{name: 'Hello'}" class="item">About</router-link>
          <!-- <a href="/#/#data-section" class="item">Data</a> -->
          <router-link :to="{name: 'Pricing'}" class="item">Pricing</router-link>
          <div class="right item">
            <!-- <a class="ui inverted button">Log in</a> -->
            <router-link :to="{name: 'Signup'}" class="ui inverted button">Sign Up</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="ui container basic segment">
      <div class="ui middle aligned center aligned grid">
        <div class="column">
          <h2 class="ui image header">
            <i class="flag us" />
            <div class="content">
              Log in to your account
            </div>
          </h2>
          <form id="login" class="ui large form" onsubmit="return false">
            <div class="field">
              <div class="ui left icon input">
                <i class="user icon"></i>
                <input type="text" name="email" placeholder="your-email@example.com"
                id="email" v-model="email"></input>
              </div>
            </div>
            <div class="field">
              <div class="ui left icon input">
                <i class="lock icon"></i>
                <input type="password" name="password" placeholder="Your password" id="password" v-model="password" ></input>
              </div>
            </div>

            <div class="ui negative message" v-if="errorMessage">
              <i class="close icon"></i>
              <div class="header">
                Oops! There was an error during login
              </div>
              <p>{{errorMessage}}</p>
            </div>

            <div class="ui fluid large primary button" :class="{ 'disabled' : !filledIn }" v-on:click="login">Login</div>

            <div class="ui error message"></div>

            <div class="ui right aligned basic segment">
              <div class="ui list">
                <a @click="forgotPasswordModal" class="item">Forgot Password</a>
                <div class="item">New to us? Sign up <router-link :to="{name: 'Signup'}">here</router-link>!</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="ui modal">
      <i class="close icon"></i>
      <div class="header">
        Profile Picture
      </div>

      <div class="description">
        <div class="ui text container">
          <p>We'll send you an email to reset your password.</p>

          <div class="ui input right aligned">
            <input type="text" placeholder="Email Address" v-model="email"></input>
          </div>
        </div>
      </div>

      <br />

      <div class="actions">
        <div class="ui black deny button">
          Nope
        </div>
        <div class="ui positive right labeled icon button">
          Yep, that's me
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var $ = window.$  // perhaps require('jQuery') would be better?
import Vue from 'vue'  // Note: is there a new require syntax for this?

export default {
  name: 'signup',
  data () {
    return {
      email: '',
      password: '',

      errorMessage: ''
    }
  },
  computed: {
    filledIn: function () {
      return !!this.email && !!this.password
    }
  },
  methods: {
    login: function () {
      // TODO move the Login
      $('#login.ui.form').form(
        {
          fields: {
            email: {
              identifier: 'email',
              rules: [
                {
                  type: 'email',
                  prompt: 'Please enter a valid email address'
                }
              ]
            },
            password: {
              identifier: 'password',
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter a password'
                },
                {
                  type: 'minLength[10]',
                  prompt: 'Your password is at least {ruleValue} characters'
                }
              ]
            }
          }
        },
        { onSuccess: this.go() }
      )
    },
    forgotPasswordModal: function () {
      Vue.nextTick(function () {
        $('.ui.modal')
          .modal('show')
      })
    },
    go: function (event, fields) {
      var that = this
      Vue.nextTick(function () {
        if ($('#login.ui.form').form('validate form')) {
          console.log('SUBMIT')
          console.log(that.email)
          console.log(that.password)

          $.post({
            url: 'https://data.altos.re/api/login',
            data: {
              email: that.email,
              password: that.password
            },
            success: function (response) {
              console.log(response)
              console.log('success')
              that.$router.push({name: 'Dashboard'})
            },
            error: function (error) {
              console.log(error)
              that.errorMessage = error.responseJSON.error
              that.password = ''
            }
          })
          // TODO post to /api/login and handle errors
        }
      })
    }
  },
  mounted: function () {
    $('.ui.sidebar')
      .sidebar('attach events', '.toc.item')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// Login.vue?844838ca